// Import 3rd Party dependencies
import { Action, AnyAction } from '@reduxjs/toolkit';

// Import from source files
import AppConfig from '../AppConfig.js';
import DefaultContextBase from '../Spa.js';
import IServiceContainerBase, { DefaultServices as DefaultServicesBase } from '../Core/IServiceContainer.js';
import DefaultServiceContainerBase from '../Core/DefaultServiceContainer.js';
import IEpiserverContextBase from '../Core/IEpiserverContext.js';
import DefaultEventEngineBase from '../Core/DefaultEventEngine.js';
import IEventEngineBase from '../Core/IEventEngine.js';
import IInitializableModuleBase, { BaseInitializableModule as CoreBaseInitializableModule } from '../Core/IInitializableModule.js';
import IStateReducerInfoBase from '../Core/IStateReducerInfo.js';

// Re-export Core namespace
export const DefaultEventEngine = DefaultEventEngineBase;
export const DefaultServiceContainer = DefaultServiceContainerBase;
export const DefaultContext = DefaultContextBase;
export const DefaultServices = DefaultServicesBase;
export const BaseInitializableModule = CoreBaseInitializableModule;
export type IEpiserverContext = IEpiserverContextBase;
export type IEventEngine = IEventEngineBase;
export type IInitializableModule = IInitializableModuleBase;
export type IServiceContainer = IServiceContainerBase;
export type IStateReducerInfo<S, A extends Action = AnyAction> = IStateReducerInfoBase<S, A>;
export type IConfig = AppConfig;